<template>
  <nav class="relative pb-8 md:mt-0 md:pb-0 container lg:w-auto mx-auto">
    <ul
      class="flex h-full flex-col grow-0 gap-4 py-4 text-lg lg:flex-row lg:gap-2 lg:pt-0 lg:font-bold bg-white rounded-xl lg:bg-transparent w-fit ml-auto"
    >
      <li
        v-for="(link, i) in serviceMenuLinks"
        :key="`global_${i}`"
        class="flex items-center px-4 lg:px-0 lg:mt-4"
      >
        <VuepalLink
          :to="link.href"
          class="flex lg:h-[50px] w-full items-center justify-end px-4 pl-2 transition-all page-landing:text-black lg:page-landing:text-white lg:page-landing:hover:text-yellow hover:text-violet duration-250 ease-in-out lg:size-auto lg:px-0 lg:pl-2 before:content-[''] before:size-3 before:rounded-full lg:page-landing:before:bg-petrol before:bg-white before:mr-2 before:-mt-0.5"
          :active-class="'lg:pl-7 before:!bg-darkGreen !text-darkGreen page-landing:lg:before:!bg-lightGreen page-landing:lg:!text-lightGreen'"
        >
          {{ link.label }}
        </VuepalLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
const { serviceMenuLinks } = useInitData()
</script>
